export function signalsLoadMore() {
  const loadMore = document.querySelector('[data-signals-load-more]');

  if (!loadMore) {
    return;
  }

  const button = loadMore.querySelector('[data-signals-load-more-button]');
  const posts = document.querySelector('#signals-posts .blog-posts-wrapper');
  const shown = loadMore.querySelector('[data-signals-shown]');

  if (!button || !posts || !shown) {
    return;
  }

  button.addEventListener('click', async function (event) {
    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    const nextPage = Number(loadMore.dataset.currentPage || 1) + 1;
    const originalText = button.textContent;
    const formData = new FormData();

    formData.append('action', 'dmc_load_more_signals');
    formData.append('nonce', loadMore.dataset.nonce || '');
    formData.append('page', String(nextPage));
    formData.append('taxonomy', loadMore.dataset.taxonomy || '');
    formData.append('term', loadMore.dataset.term || '');
    formData.append('search', loadMore.dataset.search || '');

    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading…';

    try {
      const response = await fetch(loadMore.dataset.ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      });
      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error('Unable to load Signals.');
      }

      posts.insertAdjacentHTML('beforeend', result.data.html);
      loadMore.dataset.currentPage = String(nextPage);
      shown.textContent = String(result.data.shown);

      if (!result.data.hasMore) {
        button.remove();
        return;
      }

      button.href = button.href.replace(/\/page\/\d+\/?(?:\?.*)?$/, `/page/${result.data.nextPage}/`);
    } catch (error) {
      button.textContent = 'Try again';
      return;
    } finally {
      button.removeAttribute('aria-busy');

      if (button.isConnected && button.textContent !== 'Try again') {
        button.textContent = originalText;
      }
    }
  });
}
